




















import { Component, Vue } from 'vue-property-decorator';
import { PreferencesAction } from '@/store/PreferencesModule';

@Component({})
export default class DemoDataToggle extends Vue {
  get showDemo(): boolean {
    return this.$store.getters['PreferencesModule/getShowDemo'];
  }

  async setShowDemo(value: boolean) {
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setShowDemo}`, value);
    await this.$nextTick();
    this.$root.$emit('change-policy-filter', value);
    this.$root.$emit('change-damage-filter', value);
    this.$root.$emit('change-fiv-goals-filter', value);
    this.$root.$emit('change-task-filter', value);
  }
}
